import React from 'react';
import * as classNames from 'classnames';
import Spinner from '@atlaskit/spinner';
var selfStyles = require('./ButtonAction.scss');
var ButtonAction = function (props) {
    return (React.createElement("div", { className: classNames(props.className, selfStyles.wrapper, (_a = {},
            _a[selfStyles.disabled] = props.isDisabled && !props.isWaiting,
            _a[selfStyles.waiting] = props.isWaiting,
            _a)), style: { width: props.width } }, props.isWaiting ? (React.createElement("button", null,
        React.createElement(Spinner, { invertColorboolean: false }))) : (props.children)));
    var _a;
};
ButtonAction.defaultProps = {
    isDisabled: false,
    isWaiting: false,
};
export default ButtonAction;



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/utilities/ButtonAction.tsx
// module id = 26
// module chunks = 0